import { WdxThemeColor } from '../../models';

export const STATUS_THEMECOLOR_MAP: Record<string, WdxThemeColor> = {
    Active: 'success',
    Closed: 'danger',
    Draft: 'info',
    Inactive: 'info',
};
